/* unplugin-vue-components disabled */import script from "./VideoList.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoList.vue?vue&type=script&setup=true&lang=js"

import "./VideoList.vue?vue&type=style&index=0&id=a0071efc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0071efc"]])

export default __exports__